import { useLocation } from "react-router-dom"
import { ThemeProvider } from "./components/ThemeProvider"
import { ToastProvider } from "./components/Toast"
import { LayoutV2 } from "./components/LayoutV2"
import { Router } from "./components/Router"
import { useAuth } from "./components/AuthProvider"
import { pathnameToPage } from "./lib/routes"

/**
 * Main Portal Application. V2 is the only shell; authenticated users get LayoutV2.
 */
function App() {
  const { user, isDemo, loading: authLoading } = useAuth()
  const location = useLocation()
  const { page: currentPage } = pathnameToPage(location.pathname)

  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-950">
        <div className="w-8 h-8 rounded-full border-2 border-white/10 border-t-white/50 animate-spin" />
      </div>
    )
  }

  const showLayout = (user || isDemo) && currentPage !== "login" && currentPage !== "onboarding" && currentPage !== "apply" && currentPage !== "apply/enterprise" && currentPage !== "welcome" && currentPage !== "reset-password" && currentPage !== "not-found"

  return (
    <ThemeProvider>
      <ToastProvider>
        {showLayout ? (
          <LayoutV2>
            <Router />
          </LayoutV2>
        ) : (
          <Router />
        )}
      </ToastProvider>
    </ThemeProvider>
  )
}

export default App